import { render, staticRenderFns } from "./V.vue?vue&type=template&id=6e741a5c&scoped=true"
import script from "./V.vue?vue&type=script&lang=js"
export * from "./V.vue?vue&type=script&lang=js"
import style0 from "./V.vue?vue&type=style&index=0&id=6e741a5c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e741a5c",
  null
  
)

export default component.exports